type FormEvent = React.FormEvent<HTMLFormElement>;
// type MouseEvent = React.MouseEvent<HTMLButtonElement>;
type ChangeEvent = React.ChangeEvent<HTMLInputElement>;

export type { FormEvent, ChangeEvent };

export enum FetchStatus {
    INITIAL = 'initial',
    LOADING = 'loading',
    MFA_REQUIRED = 'mfa_required',
    MFA_LOADING = 'mfa_loading',
    SUCCESS = 'success',
    ERROR = 'error'
}

export type LoginSuccessResponse = {
    status: 'ok';
    message: string; 
    userId: string;
    accessToken: string;
    refreshToken: string;
};
  
export type LoginFailureResponse = {
    status: 'fail';
    message: string;
};

export type LoginResponse = LoginSuccessResponse | LoginFailureResponse;